// extracted by mini-css-extract-plugin
export default {"ButtonUndoRedo":"ButtonUndoRedo_ButtonUndoRedo__53Dq1","icon":"ButtonUndoRedo_icon__ALdeB","label":"ButtonUndoRedo_label__2uwnK","labelIcon":"ButtonUndoRedo_labelIcon__yY+3y"};